import React from "react";

const SearchFilter = () => {
  return(
      <>
        <div className="relative w-full max-w-sm mb-1">
            <input
              type="text"
              placeholder="Search..."
              className="w-full h-25 pl-10 pr-4 py-2 border-gray-300 rounded-sm shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              style={{ border: "1px solid rgb(202 202 202)", borderRadius:"4px" }}
            />
            <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none" style={{ color : "rgb(146 146 146)"}}>
                <i className="bi bi-search"></i>
            </div>
         </div>
      
      
      </>
  )
}
export default SearchFilter;